const FieldEntryRequirement = Object.freeze({
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    NOT_ALLOWED: 'Not Allowed',
});

module.exports = FieldEntryRequirement;
